import { FC, Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Dialog, Transition } from '@headlessui/react';
import { PopupProps } from './Popup.props';
import cn from 'classnames';

import { ROUTES } from '@/utils/routes';

export const Popup: FC<PopupProps> = ({
  children,
  btnConfirmText,
  btnCancelText,
  onConfirm,
}) => {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(true);
  const [isGray, setIsGray] = useState(false);

  const handleYesClick = () => {
    localStorage.setItem('confirmation', 'true');
    setIsVisible(false);
    if (onConfirm) {
      onConfirm();
    }
  };

  const handleCloseClick = () => {
    router.push(`${ROUTES.HOME}`).then(() => {
      setIsVisible(false);
    });
  };

  useEffect(() => {
    const grayscale = localStorage.getItem('grayscale');

    if (grayscale) {
      grayscale === 'true' ? setIsGray(true) : setIsGray(false);
    }
  }, []);

  const isPopupConfirmed = localStorage.getItem('popupConfirmed');
  const shouldShowPopup =
    !isPopupConfirmed &&
    (router.pathname.includes(`${ROUTES.PRODUCTS}`) || router.query.category);

  if (!shouldShowPopup || !isVisible) {
    return null;
  }
  return (
    <Transition.Root
      appear
      show={isVisible}
      as={Fragment}
      enter="transition-opacity duration-700"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-700"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <Dialog
        as="div"
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-primaryLight bg-opacity-50 backdrop-blur-sm"
        onClose={handleCloseClick}
      >
        <Transition.Child
          as={Fragment}
          enter="transition-opacity duration-1000"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-1000"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={cn(
              'max-w-[592px] rounded-base bg-accentMain px-6 py-10 text-center text-white md:p-10',
              isGray && 'grayscale',
            )}
          >
            {/*<IconButton*/}
            {/*  icon="close_circle"*/}
            {/*  onClick={handleCloseClick}*/}
            {/*  className="absolute right-4 top-4 duration-200 hover:scale-110"*/}
            {/*/>*/}
            {children}
            <div className="flex justify-center space-x-6">
              <button
                type="button"
                onClick={handleYesClick}
                className="rounded-base border border-white bg-accentMain px-8 py-3 text-lg leading-5 text-white transition-colors duration-300 hover:bg-white hover:text-accentMain focus:bg-white focus:text-accentMain focus:outline-none"
              >
                {btnConfirmText}
              </button>
              <button
                type="button"
                onClick={handleCloseClick}
                className="rounded-base border border-white bg-accentMain px-8 py-3 text-lg leading-5 text-white transition-colors duration-300 hover:bg-white hover:text-accentMain focus:bg-white focus:text-accentMain focus:outline-none"
              >
                {btnCancelText}
              </button>
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition.Root>
  );
};
